<div class="modal fade show d-block" tabindex="-1" *ngIf="show">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow-lg rounded-3">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close btn-close-white" (click)="onCancel()"></button>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
          <button class="btn btn-success" (click)="onConfirm()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" *ngIf="show"></div>
  